const plans = {
    monthly: {
        title: "Monthly Plan",
        subtitle: 14.99,
        specialPrice: 0.49,
        specialPriceAddOn: "/ per day",
        badgeTitle: "Save 70%",
        accentColor: "#72789A",
        activePriceColor: "#9FB0D6",
        trialPriceVat: 14.99,
        priceVat: 49.99,
        oldPrice: 49.99,
        amplitudeId: "30days_49.99$_with_trial_30days_14.99$",
    },
    trial24h: {
        title: "24h Trial",
        subtitle: "of full access",
        specialPrice: 4.99,
        specialPriceAddOn: "only",
        badgeTitle: "Most popular",
        accentColor: "#5FCB39",
        activePriceColor: "#5FCB39",
        priceVat: 49.99,
        trialPriceVat: 4.99,
        oldPrice: 9.99,
        amplitudeId: "1month_49.99$_with_trial_1day_4.99$",
    },
};

const plansHighPrices = {
    monthly: {
        title: "Monthly Plan",
        subtitle: 23.69,
        specialPrice: 0.79,
        specialPriceAddOn: "/ per day",
        badgeTitle: "Best Value",
        accentColor: "#72789A",
        activePriceColor: "#9FB0D6",
        trialPriceVat: 23.69,
        priceVat: 49.99,
        oldPrice: 49.99,
        amplitudeId: "30days_49.99$_with_trial_30days_23.69$",
    },
    trial24h: {
        title: "24h Trial",
        subtitle: "of full access",
        specialPrice: 7.99,
        specialPriceAddOn: "only",
        badgeTitle: "Popular",
        accentColor: "#5FCB39",
        activePriceColor: "#5FCB39",
        priceVat: 49.99,
        trialPriceVat: 7.99,
        oldPrice: 49.99,
        amplitudeId: "30days_49.99$_with_trial_1day_7.99$",
    },
};

export const planVariantsV3 = [plans.monthly, plans.trial24h];
export const planVariantsV3HighPrices = [plansHighPrices.monthly, plansHighPrices.trial24h];
